import Swal from "sweetalert2";
import print from "../assets/icons/print.svg";

export const showAdmitCardActions = ({
  admitCardUrl,
  onPrint,
  onShare,
}) => {
  Swal.fire({
    title: "Admit Card Issued Successfully ✅",
    html: `
      <div style="
        display:flex;
        gap:15px;
        justify-content:center;
        margin-top:25px;
        padding-bottom:20px;
      ">
        <button id="print-btn" class="swal2-confirm swal2-styled" style="min-width: 80px; padding: 8px 12px;    display:flex;
    align-items:center;
    gap:6px;
">
          <img src="${print}" width="20" height="20" />
          Print
        </button>

        <button id="share-btn" class="swal2-confirm swal2-styled" style="min-width: 80px; padding: 8px 12px;">
          <svg height="20" width="20" viewBox="0 0 24 24" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <circle cx="18" cy="6" r="3" stroke="white" stroke-width="2"/>
            <circle cx="6" cy="12" r="3" stroke="white" stroke-width="2"/>
            <circle cx="18" cy="18" r="3" stroke="white" stroke-width="2"/>
            <path d="M8.5 13.5L15.5 16.5" stroke="white" stroke-width="2"/>
            <path d="M8.5 10.5L15.5 7.5" stroke="white" stroke-width="2"/>
          </svg>
          Share
        </button>

        <button id="view-btn" class="swal2-confirm swal2-styled" style="min-width: 80px; padding: 8px 12px;">
        <svg viewBox="0 0 24 24" fill="none" height="20" width="20"
                                                xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <circle cx="12" cy="12" r="2.5" stroke="#fff"></circle> <path d="M18.2265 11.3805C18.3552 11.634 18.4195 11.7607 18.4195 12C18.4195 12.2393 18.3552 12.366 18.2265 12.6195C17.6001 13.8533 15.812 16.5 12 16.5C8.18799 16.5 6.39992 13.8533 5.77348 12.6195C5.64481 12.366 5.58048 12.2393 5.58048 12C5.58048 11.7607 5.64481 11.634 5.77348 11.3805C6.39992 10.1467 8.18799 7.5 12 7.5C15.812 7.5 17.6001 10.1467 18.2265 11.3805Z" stroke="#fff"></path> <path d="M17.5 3.5H17.7C19.4913 3.5 20.387 3.5 20.9435 4.0565C21.5 4.61299 21.5 5.50866 21.5 7.3V7.5" stroke="#fff" stroke-linecap="round"></path> <path d="M17.5 20.5H17.7C19.4913 20.5 20.387 20.5 20.9435 19.9435C21.5 19.387 21.5 18.4913 21.5 16.7V16.5" stroke="#fff" stroke-linecap="round"></path> <path d="M6.5 3.5H6.3C4.50866 3.5 3.61299 3.5 3.0565 4.0565C2.5 4.61299 2.5 5.50866 2.5 7.3V7.5" stroke="#fff" stroke-linecap="round"></path> <path d="M6.5 20.5H6.3C4.50866 20.5 3.61299 20.5 3.0565 19.9435C2.5 19.387 2.5 18.4913 2.5 16.7V16.5" stroke="#fff" stroke-linecap="round"></path> </g></svg>
          View
        </button>
      </div>
    `,
    showConfirmButton: false,
    allowEnterKey: false, // 🔴 Disable SweetAlert default Enter behavior
    customClass: {
      title: 'swal-title-small'
    },
    didOpen: () => {
      const printBtn = document.getElementById("print-btn");
      const shareBtn = document.getElementById("share-btn");
      const viewBtn = document.getElementById("view-btn");

      // Click bindings
      printBtn.onclick = () => {
        onPrint();
        // Swal.close();
      };

      shareBtn.onclick = onShare;

      viewBtn.onclick = () => {
        if (admitCardUrl) window.open(admitCardUrl, "_blank");
      };

      // ⭐ Auto-focus PRINT
      printBtn.focus();

      // ⭐ ENTER KEY → PRINT
      const handleEnter = (e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          onPrint();
          // Swal.close();
        }
      };

      document.addEventListener("keydown", handleEnter);

      // ⭐ Cleanup on close
      Swal.getPopup().addEventListener("remove", () => {
        document.removeEventListener("keydown", handleEnter);
      });
    },
  });
};
